import SliderComponent from "./slider.js";
import SliderThumb from "./slider-thumb.js";
const Slider = SliderComponent;
Slider.Thumb = SliderThumb;
export default Slider;
